<template>
	<button
		v-if="link.type === 'tallyForm'"
		ref="el"
		data-component="button-simple"
		@mouseenter="onMouseEnter"
		@mouseleave="onMouseLeave"
		@mousemove="onMouseMove"
		:data-tally-open="link.tallyForm.formId"
		data-tally-layout="modal"
	>
		<span ref="wrapper" class="inner-wrapper">
			<span ref="bg" class="bg"></span>
		</span>
		<span class="-text-2 label">{{ label }}</span>
	</button>

	<nuxt-link v-else-if="link.type === 'external'" :to="link.url" target="_blank" rel="noopener noreferrer" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave" @mousemove="onMouseMove">
		<button ref="el" data-component="button-simple">
			<span ref="wrapper" class="inner-wrapper">
				<span ref="bg" class="bg"></span>
			</span>
			<span class="-text-2 label">{{ label }}</span>
		</button>
	</nuxt-link>

	<nuxt-link v-else-if="link.type === 'internal'" :to="link.url" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave" @mousemove="onMouseMove">
		<button ref="el" data-component="button-simple">
			<span ref="wrapper" class="inner-wrapper">
				<span ref="bg" class="bg"></span>
			</span>
			<span class="-text-2 label">{{ label }}</span>
		</button>
	</nuxt-link>
</template>

<script setup>
import { useTally } from '~/composables'
import { useScreen } from 'vue-screen'

const screen = useScreen()

const props = defineProps({
	label: { type: String, default: undefined },
	link: { type: Object, default: undefined },
	// dark: { type: Boolean, default: false },
	// size: { type: String, default: 'm' },
})

const el = ref(null)
const bg = ref(null)
const wrapper = ref(null)
const context = inject('pageContext')

const tallyLoaded = useTally()

const setup = () => {}
const init = () => {}
const kill = () => {}

import { gsap } from 'gsap'

const onMouseEnter = (e) => {
	if (screen.touch) return

	gsap.killTweensOf(bg.value)
	gsap.killTweensOf(wrapper.value)
	const rect = el.value.getBoundingClientRect()
	const x = e.clientX - rect.left
	const y = e.clientY - rect.top

	gsap.set(bg.value, { x, y, xPercent: -50, yPercent: -50 })
	gsap.to(bg.value, { scale: 50, duration: 0.8, ease: 'circ.out' })
	gsap.to(wrapper.value, { scale: 1.05, duration: 0.8, ease: 'power2.out' })
}

const onMouseMove = (e) => {
	if (screen.touch) return

	const rect = el.value.getBoundingClientRect()
	const x = e.clientX - rect.left
	const y = e.clientY - rect.top

	gsap.set(bg.value, { x, y })
}

const onMouseLeave = (e) => {
	if (screen.touch) return

	gsap.killTweensOf(bg.value)
	gsap.killTweensOf(wrapper.value)
	gsap.to(bg.value, { scale: 0, duration: 0.5, ease: 'expo.out' })
	gsap.to(wrapper.value, { scale: 1, duration: 0.4, ease: 'power2.out' })
}

onMounted(() => {
	gsap.set(bg.value, { scale: 0, xPercent: -50, yPercent: -50 })
})
</script>

<style lang="scss" scoped>
[data-component='button-simple'] {
	position: relative;
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;

	padding: rs(12, 12) rs(16, 16);
	isolation: isolate;

	@include extend_hitbox(10);

	.inner-wrapper {
		position: absolute;
		inset: 0;
		overflow: hidden;

		border-radius: rs(40, 40);
		border: 1px solid var(--color-geral-creme);
	}

	.label {
		position: relative;

		mix-blend-mode: difference;
		color: var(--color-geral-creme);

		z-index: 1;

		user-select: none;
	}

	.bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 10px;
		height: 10px;
		border-radius: 50%;
		background-color: var(--color-geral-creme);
		pointer-events: none;
	}
}
</style>
